import { render, staticRenderFns } from "./tracking-add.vue?vue&type=template&id=456cfedb"
import script from "./tracking-add.vue?vue&type=script&lang=js"
export * from "./tracking-add.vue?vue&type=script&lang=js"
import style0 from "./tracking-add.vue?vue&type=style&index=0&id=456cfedb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports